import React, { useState } from "react";
import { IconAttachment, IconCode, IconQr } from "../../../../utils/icons";
import { EmbedCodePanel } from "./EmbedCodePanel";
import { IBrand } from "../../../brand/team/data/type";
import { PreviewUrlPanel } from "./PreviewUrlPanel";
import { QrPanel } from "./QrPanel";
import { TabHeader, TabPanel } from "../../../../components/Tabs";

interface Props {
  brand: IBrand;
  openSettings: () => void;
  s3id?: number | null;
}

export function ShareVideoModal(props: Props) {
  const [selectedTab, setSelectedTab] = useState(0);

  const tabHeader = [
    {
      value: 0,
      text: "Embed Code",
      Icon: IconCode,
    },
    {
      value: 1,
      text: "Video URL",
      Icon: IconAttachment,
    },
    {
      value: 2,
      text: "QR Code",
      Icon: IconQr,
    },
  ];
  return (
    <div className="flex flex-col h-full">
      <div className="shrink-0">
        <TabHeader
          tabs={tabHeader}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          variant="pill"
        />
      </div>
      <TabPanel value={selectedTab} index={0} className="flex-1 min-h-0">
        <EmbedCodePanel {...props} />
      </TabPanel>
      <TabPanel value={selectedTab} index={1} className="flex-1 min-h-0">
        <PreviewUrlPanel {...props} />
      </TabPanel>
      <TabPanel value={selectedTab} index={2} className="flex-1 min-h-0">
        <QrPanel {...props} />
      </TabPanel>
    </div>
  );
}
